import {
  FETCH_TRADE_FEES_SUCCESS,
  FETCH_TRADE_FEES_FAIL,
} from '../actions/types';

const initialState = {
  fees: {},
  volume30: {},
  errors: [],
};

const fees = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRADE_FEES_SUCCESS:
      return {
        ...state,
        fees: action.payload.data,
        volume30: action.payload.volume30,
        loading: false,
      };
    case FETCH_TRADE_FEES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default fees;
